<div class="grid-container padding-y-4">
  <div class="grid-row grid-col-12">
    <legend class="usa-legend usa-legend--large">{{title}}</legend>
    <p class="define-text-color-no-records">Note: Information entered below will be identified on the  "{{routeParamBusinessType}} - Control Screen" for contact purposes when booking shipments electronically via
    TMSS 2.0. If left blank, the information for the "Authorized Official" on file will be identified.</p>
  </div>
  <form [formGroup]="carrierContactInfoForm">
    <fieldset class="usa-fieldset">
      @if (hhgAndFrt) {
        <div class="grid-row">
          <div class="usa-radio">
            <input
              class="usa-radio__input"
              formControlName="options"
              id="hhg"
              type="radio"
              value="HHG"
              (click)="onContactTypeChg('HHG')"/>
            <label class="usa-radio__label" for="hhg">HHG</label>
          </div>
          <div class="usa-radio">
            <input
              class="usa-radio__input"
              formControlName="options"
              id="frt"
              type="radio"
              value="FRT"
              (click)="onContactTypeChg('FRT')"/>
            <label class="usa-radio__label" for="frt">FRT</label>
          </div>
          @if (this.carrierContactInfoForm.get('options').hasError('required')) {
            <div>
              <small class="text-danger"> <span class="fa fa-warning"></span>
              Please choose HHG or FRT
            </small>
          </div>
        }
      </div>
    }
    <div class="grid-row grid-gap-0">
      <div class="grid-col-4">
        <label for="firstName" class="usa-label">First Name
          <abbr title="required"
          class="usa-hint usa-hint--required">*</abbr>
        </label>
        <input type="text"
          id="firstName"
          formControlName="firstName"
          class="usa-input"
          size='45'
          maxlength='45'>
        @if (this.carrierContactInfoForm.get('firstName').invalid && (this.carrierContactInfoForm.get('firstName').touched
          || this.carrierContactInfoForm.get('firstName').dirty)) {
          <div
            >
            <small class="text-danger"> <span class="fa fa-warning"></span>
            First Name is required
          </small>
        </div>
      }
    </div>
    <div class="grid-col-4">
      <label for="middleInitial" class="usa-label">Middle Initial</label>
      <input type="text"
        id="middleInitial"
        formControlName="middleInitial"
        class="usa-input"
        size='1'
        maxlength='1'>
    </div>
    <div class="grid-col-4">
      <label for="lastName" class="usa-label">Last Name
        <abbr title="required"
        class="usa-hint usa-hint--required">*</abbr>
      </label>
      <input type="text"
        id="lastName"
        formControlName="lastName"
        class="usa-input"
        size='45'
        maxlength='45'>
      @if (this.carrierContactInfoForm.get('lastName').invalid && (this.carrierContactInfoForm.get('lastName').touched
        || this.carrierContactInfoForm.get('lastName').dirty)) {
        <div
          >
          <small class="text-danger"> <span class="fa fa-warning"></span>
          Last Name is required
        </small>
      </div>
    }
  </div>
</div>

<div class="grid-row">
  <div class="grid-col-4">
    <label for="phone" class="usa-label">Phone
      <abbr title="required"
      class="usa-hint usa-hint--required">*</abbr>
    </label>
    <input type="text"
      id="phone" appNumbersOnly
      formControlName="phone"
      maxlength="15"
      class="usa-input">
    @if (this.carrierContactInfoForm.get('phone').touched
      && this.carrierContactInfoForm.get('phone').hasError('required')) {
      <div
        >
        <small class="text-danger"> <span class="fa fa-warning"></span>
        Phone Number is required
      </small>
    </div>
  }
  @if (this.carrierContactInfoForm.get('phone').touched
    && this.carrierContactInfoForm.get('phone').hasError('phoneNumber')) {
    <div
      >
      <small class="text-danger"> <span class="fa fa-warning"></span>
      Phone Number is invalid
    </small>
  </div>
}
</div>
<div class="grid-col-4">
  <label for="phoneExt" class="usa-label">Ext</label>
  <input type="text" appNumbersOnly
    id="phoneExt"
    formControlName="phoneExt"
    class="usa-input"
    [maxlength]="10">
</div>
</div>
<div class="grid-row">
  <div class="grid-col-4">
    <label for="email" class="usa-label">Email
      <abbr title="required"
      class="usa-hint usa-hint--required">*</abbr>
    </label>
    <input type="text"
      id="email"
      formControlName="email"
      class="usa-input"
      maxlength="254">
    @if (this.carrierContactInfoForm.get('email').touched
      && this.carrierContactInfoForm.get('email').hasError('required')) {
      <div
        >
        <small class="text-danger"> <span class="fa fa-warning"></span>
        Email is required
      </small>
    </div>
  }
  @if (this.carrierContactInfoForm.get('email').touched
    && this.carrierContactInfoForm.get('email').hasError('email')) {
    <div
      >
      <small class="text-danger"> <span class="fa fa-warning"></span>
      Email is invalid
    </small>
  </div>
}
</div>
</div>

<div class="grid-row margin-top-4">
  <button type="button" class="usa-button"
    [disabled]="carrierContactInfoForm.invalid"
    (click)="saveContactInfo()">Save
  </button>
</div>
</fieldset>
</form>
</div>













